module.exports = __webpack_public_path__ + "static/p3-f466096bd08d5bf514c9d41af247ae62.jpg";